import {createWebHistory, createRouter} from "vue-router";
import {SystemRole} from "./utils/SystemRole";

const LayoutDashboard = () => import("./views/layout/LayoutDashboard");
const LoginView = () => import("./views/LoginView");
const RegisterView = () => import("./views/RegisterView");
const UserListView = () => import("./views/user/UserListView");
const UserFormView = () => import("./views/user/UserFormView");
const UserDetailsView = () => import("./views/user/UserDetailsView");
const LayoutSimple = () => import("./views/layout/LayoutSimple");
const ForbiddenView = () => import("./views/ForbiddenView");
const NotFoundView = () => import("./views/NotFoundView");
const ErrorView = () => import("./views/ErrorView");
const PasswordRemindView = () => import("./views/PasswordRemindView");
const ChangePasswordView = () => import("./views/ChangePasswordView");
const ChangeMyPasswordView = () => import("./views/ChangeMyPasswordView.vue");
const LayoutPublic = () => import("./views/layout/LayoutPublic");
const PublicView = () => import("./views/public/PublicView");
const PositionDictView = () => import("@/views/dictPosition/PositionDictView");
const PositionDetailsView = () => import("@/views/dictPosition/PositionDetailsView");
const FieldDictView = () => import("@/views/dictField/FieldDictView");
const FormMPSView = () => import("./views/formMPS/FormMPSView");
const FormMCHView = () => import("./views/formMCH/FormMCHView");
const FormMNGView = () => import("./views/formMNG/FormMNGView");
const MonitoringProgramView = () => import("./views/monitoringProgram/MonitoringProgramView");
const FieldDetailsView = () => import("@/views/dictField/FieldDetailsView");
const ProgramsView = () => import("@/views/programs/ProgramsView");
const ProgramsListView = () => import("@/views/programsList/ProgramsListView");
const RawDataView = () => import("./views/rawData/RawDataView");
const DataAggregatesView = () => import("./views/dataAggregates/DataAggregatesView");
const TransectDictView = () => import("@/views/dictTransect/TransectDictView.vue");
const TransectDetailsView = () => import("@/views/dictTransect/TransectDetailsView.vue");
const ToCreateForm = () => import("./views/monitoringProgram/components/controls/ToCreateForm.vue");
const DangerView = () => import("@/views/dangers/DangerView.vue");
const SemiRawDataView = () => import("@/views/semiRawData/SemiRawDataView.vue");
const FormMPPLView = () => import("@/views/formMPPL/FormMPPLView.vue");
const FormMPMView = () => import("@/views/formMPM/FormMPMView.vue");
const HabitatDataView = () => import("@/views/habitatData/HabitatDataView.vue");
const FormMZPMView = () => import("@/views/formMZPM/FormMZPMView.vue");
const FormMWOTView = () => import("@/views/formMWOT/FormMWOTView.vue");
const FormMKRView = () => import("@/views/formMKR/FormMKRView.vue");
const FormMGRView = () => import("@/views/formMGR/FormMGRView.vue");
const FormMKOView = () => import("@/views/formMKO/FormMKOView.vue");
const FormMSKRView = () => import("@/views/formMSKR/FormMSKRView.vue");
const FormMRCView = () => import("@/views/formMRC/FormMRCView.vue");
const FormMZPWView = () => import("@/views/formMZPW/FormMZPWView.vue");
const FormMGZView = () => import("@/views/formMGZ/FormMGZView.vue");
const FormMCZView = () => import("@/views/formMCZ/FormMCZView.vue");
const FormMPPMView = () => import("@/views/formMPPM/FormMPPMView.vue");
const SendEmail = () => import("@/views/email/SendEmail");
const EmailTemplate = () => import("@/views/email/EmailTemplate");
const EmailHistory = () => import("@/views/email/EmailHistory");
const EnumDictView = () => import("@/views/enumDict/EnumDictView.vue");
const AreaDictView = () => import("@/views/areaDict/AreaDictView.vue");
const AreaDictDetails = () => import("@/views/areaDict/AreaDictDetails.vue");
const MammalsDictView = () => import("@/views/mammalsDict/MammalsDictView.vue");
const CreateMammalView = () => import("@/views/mammalsDict/CreateMammalView.vue");
const BirdsDictView = () => import("@/views/birdsDict/BirdsDictView.vue");
const BirdsDetailsView = () => import("@/views/birdsDict/BirdsDetailsView.vue");
const FormMWOPView = () => import("@/views/formMWOP/FormMWOPView.vue");
const TrendsView = () => import("@/views/trendsTable/TrendsView");
const IndicatorsView = () => import("@/views/indicatorsTable/IndicatorsView");
const FormMPDView = () => import("@/views/formMPD/FormMPDView.vue");
const PointDictView = () => import("@/views/dictPoint/PointDictView.vue");
const PointDetailsView = () => import("@/views/dictPoint/PointDetailsView.vue");
const FormMDUView = () => import("@/views/formMDU/FormMDUView.vue");
const FormMLSView = () => import("@/views/formMLS/FormMLSView.vue");
const FormMLSLView = () => import("@/views/formMLSL/FormMLSLView.vue");
const FormMNZView = () => import("@/views/formMNZ/FormMNZView.vue");
const FormTransectZeroView = () => import("@/views/formTransectZero/FormTransectZeroView.vue");
const FormPointZeroView = () => import("@/views/formPointZero/FormPointZeroView.vue");
const FormMPGView = () => import("@/views/formMPG/FormMPGView.vue");
const FormMPWRView = () => import("@/views/formMPWR/FormMPWRView.vue");
const FormMPOView = () => import("@/views/formMPO/FormMPOView.vue");
const FormMZOView = () => import("@/views/formMZO/FormMZOView.vue");
const FormMSLView = () => import("@/views/formMSL/FormMSLView.vue");
const FormMMCView = () => import("@/views/formMMC/FormMMCView.vue");
const FormMFGPView = () => import("@/views/formMFGP/FormMFGPView.vue");
const FormMRDView = () => import("@/views/formMRD/FormMRDView.vue");
const FormMCYView = () => import("@/views/formMCY/FormMCYView.vue");
const ProgramDictView = () => import("@/views/programsTable/ProgramDictView.vue");
const ProgramDetailsView = () => import("@/views/programsTable/ProgramDetailsView.vue");
const EventLogsView = () => import("@/views/eventLogsTable/EventLogsView.vue");
const LogLogsView = () => import("@/views/logLogs/LogLogsView.vue");
const FileArchiveView = () => import("@/views/fileArchive/FileArchiveView.vue");
const WhatsNewView = () => import("./views/WhatsNewView.vue");
const SpeciesSettingsView = () => import("./views/SpeciesSettingsView.vue");
const AdministrativeTools = () => import("@/views/administrativeTools/AdministrativeTools.vue");
const SmtpForm = () => import("@/views/email/SmtpForm.vue");
const TermsView = () => import("@/views/terms/TermsView.vue");
const ReportsView = () => import("@/views/reports/ReportsView.vue");
const ReportDetails = () => import("@/views/reports/ReportDetails.vue");
const SecretLogsView = () => import("@/views/SecretLogsView.vue");

const routes = [
        {
            path: "/",
            name: "home",
            component: LayoutDashboard,
            meta: {requiresAuth: true},
            children: [
                {
                    path: "/home",
                    component: ProgramsListView,
                    name: "homeProgramsList",
                    alias: "/",
                },
                {
                    path: "/forbidden",
                    name: "forbidden",
                    component: ForbiddenView,
                },
                {
                    path: "/user",
                    children: [
                        {
                            path: "list",
                            name: "userList",
                            component: UserListView,
                            meta: {roles: [SystemRole.ADMIN, SystemRole.MAIN_COORDINATOR, SystemRole.TECHNICAL_COORDINATOR, SystemRole.NATIONAL_COORDINATOR]},
                        },
                        {
                            path: "create",
                            name: "userCreate",
                            component: UserFormView,
                            meta: {roles: [SystemRole.ADMIN, SystemRole.MAIN_COORDINATOR, SystemRole.TECHNICAL_COORDINATOR, SystemRole.NATIONAL_COORDINATOR]},
                        },
                        {
                            path: "edit/:id",
                            name: "userEdit",
                            component: UserFormView,
                            meta: {roles: [SystemRole.ADMIN, SystemRole.MAIN_COORDINATOR, SystemRole.TECHNICAL_COORDINATOR, SystemRole.NATIONAL_COORDINATOR]},
                        },
                        {
                            path: "details/:id",
                            name: "userDetails",
                            component: UserDetailsView,
                            meta: {roles: [SystemRole.ADMIN, SystemRole.MAIN_COORDINATOR, SystemRole.TECHNICAL_COORDINATOR, SystemRole.NATIONAL_COORDINATOR]},
                        },
                    ],
                },
                {
                    path: "/programs-list",
                    component: ProgramsView,
                    name: "programsList",
                },
                {
                    path: "/form/MPS/:id",
                    component: FormMPSView,
                    name: "formMPS",
                },
                {
                    path: "/form/MCH/:id",
                    component: FormMCHView,
                    name: "formMCH",
                },
                {
                    path: "/form/MLS/:id",
                    component: FormMLSView,
                    name: "formMLS",
                },
                {
                    path: "/form/MLSL/:id",
                    component: FormMLSLView,
                    name: "formMLSL",
                },
                {
                    path: "/form/MNG/:id",
                    component: FormMNGView,
                    name: "formMNG",
                },
                {
                    path: "/form/MPD/:id",
                    component: FormMPDView,
                    name: "formMPD",
                },
                {
                    path: "/form/MPPL/:id",
                    component: FormMPPLView,
                    name: "formMPPL",
                },
                {
                    path: "/form/MPM/:id",
                    component: FormMPMView,
                    name: "formMPM",
                },
                {
                    path: "/form/MZPM/:id",
                    component: FormMZPMView,
                    name: "formMZPM",
                },
                {
                    path: "/form/MWOT/:id",
                    component: FormMWOTView,
                    name: "formMWOT",
                },
                {
                    path: "/form/MWOP/:id",
                    component: FormMWOPView,
                    name: "formMWOP",
                },
                {
                    path: "/form/MOP/:id",
                    component: FormMGRView,
                    name: "formMOP",
                },
                {
                    path: "/form/MPB/:id",
                    component: FormMGRView,
                    name: "formMPB",
                },
                {
                    path: "/form/MRY/:id",
                    component: FormMGRView,
                    name: "formMRY",
                },
                {
                    path: "/form/MOG/:id",
                    component: FormMGRView,
                    name: "formMOG",
                },
                {
                    path: "/form/MKR/:id",
                    component: FormMKRView,
                    name: "formMKR",
                },
                {
                    path: "/form/MKO/:id",
                    component: FormMKOView,
                    name: "formMKO",
                },
                {
                    path: "/form/MSKR/:id",
                    component: FormMSKRView,
                    name: "formMSKR",
                },
                {
                    path: "/form/MRC/:id",
                    component: FormMRCView,
                    name: "formMRC",
                },
                {
                    path: "/form/MZPW/:id",
                    component: FormMZPWView,
                    name: "formMZPW",
                },
                {
                    path: "/form/MGZ/:id",
                    component: FormMGZView,
                    name: "formMGZ",
                },
                {
                    path: "/form/MPPM/:id",
                    component: FormMPPMView,
                    name: "formMPPM",
                },
                {
                    path: "/form/MCZ/:id",
                    component: FormMCZView,
                    name: "formMCZ",
                },
                {
                    path: "/form/MDU/:id",
                    component: FormMDUView,
                    name: "formMDU",
                },
                {
                    path: "/form/MMC/:id",
                    component: FormMMCView,
                    name: "formMMC",
                },
                {
                    path: "/form/MNZ/:id",
                    component: FormMNZView,
                    name: "formMNZ",
                },
                {
                    path: "/form/MPG/:id",
                    component: FormMPGView,
                    name: "formMPG",
                },
                {
                    path: "/form/MPO/:id",
                    component: FormMPOView,
                    name: "formMPO",
                },
                {
                    path: "/form/MPWR/:id",
                    component: FormMPWRView,
                    name: "formMPWR",
                },
                {
                    path: "/form/MZO/:id",
                    component: FormMZOView,
                    name: "formMZO",
                },
                {
                    path: "/form/MSL/:id",
                    component: FormMSLView,
                    name: "formMSL",
                },
                {
                    path: "/form/MFGP/:id",
                    component: FormMFGPView,
                    name: "formMFGP",
                },
                {
                    path: "/form/MRD/:id",
                    component: FormMRDView,
                    name: "formMRD",
                },
                {
                    path: "/form/MCY/:id",
                    component: FormMCYView,
                    name: "formMCY",
                },
                {
                    path: "/form-zero/transect/:id",
                    component: FormTransectZeroView,
                    name: "transectZeroForm",
                },
                {
                    path: "/form-zero/point/:id",
                    component: FormPointZeroView,
                    name: "pointZeroForm",
                },
                {
                    path: "/monitoring-program/:id",
                    component: MonitoringProgramView,
                    name: "monitoringProgram",
                },
                {
                    path: "/createForm",
                    component: ToCreateForm,
                    name: "toCreateForm",
                },
                {
                    path: "/program",
                    component: ProgramDictView,
                    name: "programDictView",
                },
                {
                    path: "/program/:programName",
                    component: ProgramDetailsView,
                    name: "programDetails",
                },
                {
                    path: "/position",
                    component: PositionDictView,
                    name: "positionDictView",
                },
                {
                    path: "/position/:id",
                    component: PositionDetailsView,
                    name: "positionDetails",
                },
                {
                    path: "/position/create",
                    component: PositionDetailsView,
                    name: "createPosition",
                },
                {
                    path: "/field",
                    name: "fieldDictView",
                    component: FieldDictView,
                },
                {
                    path: "/field/:id",
                    name: "fieldDetails",
                    component: FieldDetailsView,
                },
                {
                    path: "/field/create",
                    component: FieldDetailsView,
                    name: "createField",
                },
                {
                    path: "/point",
                    component: PointDictView,
                    name: "pointDictView",
                },
                {
                    path: "/point/create",
                    component: PointDetailsView,
                    name: "createPoint",
                },
                {
                    path: "/point/:id",
                    component: PointDetailsView,
                    name: "pointDetails",
                },
                {
                    path: "/transect",
                    component: TransectDictView,
                    name: "transectDictView",
                },
                {
                    path: "/transect/create",
                    component: TransectDetailsView,
                    name: "createTransect",
                },
                {
                    path: "/transect/:id",
                    component: TransectDetailsView,
                    name: "transectDetails",
                },
                {
                    path: "/raw-data/:programCode",
                    name: "RawDataView",
                    component: RawDataView,
                },
                {
                    path: "/dangers",
                    name: "DangerView",
                    component: DangerView,
                },
                {
                    path: "/semi-raw-data",
                    name: "SemiRawDataView",
                    component: SemiRawDataView,
                },
                {
                    path: "/data-aggregates",
                    name: "DataAggregatesView",
                    component: DataAggregatesView,
                },
                {
                    path: "/habitat-data/:programCode",
                    name: "HabitatDataView",
                    component: HabitatDataView,
                },
                {
                    path: "/send-email",
                    name: "SendEmail",
                    component: SendEmail,
                },
                {
                    path: "/email-template",
                    name: "EmailTemplate",
                    component: EmailTemplate,
                },
                {
                    path: "/email-history",
                    name: "EmailHistory",
                    component: EmailHistory,
                },
                {
                    path: "/trends",
                    name: "TrendsView",
                    component: TrendsView,
                },
                {
                    path: "/indicators",
                    name: "IndicatorsView",
                    component: IndicatorsView,
                },
                {
                    path: "/event-logs",
                    name: "EventLogsView",
                    component: EventLogsView,
                },
                {
                    path: "/log-logs",
                    name: "LogLogsView",
                    component: LogLogsView,
                },
                {
                    path: "/dicts/:dict",
                    name: "EnumDictView",
                    component: EnumDictView,
                },
                {
                    path: "/areaDicts/:dict",
                    name: "AreaDictView",
                    component: AreaDictView,
                },
                {
                    path: "/areaDicts/:dict/:id",
                    name: "AreaDictDetails",
                    component: AreaDictDetails,
                },
                {
                    path: "/dicts/mammals",
                    name: "MammalsDictView",
                    component: MammalsDictView,
                },
                {
                    path: "/create-mammal",
                    name: "CreateMammal",
                    component: CreateMammalView,
                },
                {
                    path: "/dicts/birds",
                    name: "BirdsDictView",
                    component: BirdsDictView,
                },
                {
                    path: "/bird-dict/:id",
                    name: "BirdsDetailsView",
                    component: BirdsDetailsView,
                },
                {
                    path: "/file-archive",
                    name: "FileArchiveView",
                    component: FileArchiveView,
                },
                {
                    path: "/change-my-password",
                    name: "changeMyPassword",
                    component: ChangeMyPasswordView,
                },
                {
                    path: "/species-settings",
                    name: "speciesSettings",
                    component: SpeciesSettingsView,
                },
                {
                    path: "/whats-new",
                    name: "whatsNew",
                    component: WhatsNewView,
                    meta: {roles: [SystemRole.ADMIN, SystemRole.MAIN_COORDINATOR, SystemRole.TECHNICAL_COORDINATOR, SystemRole.NATIONAL_COORDINATOR]},
                },
                {
                    path: "/administrative-tools",
                    name: "administrativeTools",
                    component: AdministrativeTools,
                },
                {
                    path: "/smtp-settings",
                    name: "smtpSettings",
                    component: SmtpForm,
                    meta: {roles: [SystemRole.ADMIN]},
                },
                {
                    path: "/:type",
                    name: "termsView",
                    component: TermsView,
                },
                {
                    path: "/reports",
                    name: "reportsView",
                    component: ReportsView,
                },
                {
                    path: "/reports/:id",
                    name: "reportDetails",
                    component: ReportDetails,
                },
                {
                    path: "/secret-logs",
                    name: "secretLogs",
                    component: SecretLogsView,
                    meta: {roles: [SystemRole.ADMIN]},
                },
            ],
        },
        {
            component: LayoutPublic,
            path: "/",
            children: [
                {
                    path: "/",
                    name: "public",
                    component: PublicView,
                },
            ],
        },
        {
            name: "layoutSimple",
            component: LayoutSimple,
            path: "/",
            children: [
                {
                    path: "/login",
                    name: "login",
                    component: LoginView,
                },
                {
                    path: "/register",
                    name: "register",
                    component: RegisterView,
                },
                {
                    path: "/remind",
                    name: "remindPassword",
                    component: PasswordRemindView,
                },
                {
                    path: "/change-password",
                    name: "changePassword",
                    component: ChangePasswordView,
                },
                // {
                //     path: "/forbidden",
                //     name: "forbidden",
                //     component: ForbiddenView,
                // },
                {
                    path: "/error",
                    name: "error",
                    component: ErrorView,
                },
                {
                    path: "/:pathMatch(.*)*",
                    name: "notFound",
                    component: NotFoundView,
                },
            ],
        },
    ];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
